<footer class="footer vsp-footer">
  <div class="footer-content">
    <span class="vsp-footer-item"><!-- Copyright -->© {{ currentYear }} Eyefinity, Inc.</span>
    <span class="divider"></span>
    <a href="{{ config.footerLinksUrl }}/legal/privacy-and-security-policy" class="vsp-footer-item vsp-footer-link" target="_blank">
      Privacy and Security Policy
    </a>
    <span class="divider"></span>
    <a href="{{ config.footerLinksUrl }}/resource/support/contact-us.html" class="vsp-footer-item vsp-footer-link" target="_blank">
      Customer Care
    </a>
    <span class="divider"></span>
    <a href="{{ config.footerLinksUrl }}/legal/system-requirements.html" class="vsp-footer-item vsp-footer-link" target="_blank">
      System Requirements
    </a>
    <span class="divider"></span>
    <a href="{{ config.footerLinksUrl }}/legal/terms-and-conditions-of-use.html" class="vsp-footer-item vsp-footer-link" target="_blank">
      Terms and Conditions
    </a>
    <span class="divider"></span>
    <a href="{{ config.footerLinksUrl }}/legal/notice-of-privacy-practices" class="vsp-footer-item vsp-footer-link" target="_blank">
      Notice of Privacy Practices
    </a>
    <span class="divider"></span>
    <a href="{{ config.footerLinksUrl }}/legal/provider-business-associate-agreement.html" class="vsp-footer-item vsp-footer-link" target="_blank">
      BAA
    </a>
    <span *ngIf="showBuildNumbers" class="divider"></span>
    <span *ngIf="showBuildNumbers" class="vsp-footer-item">
      Build #: {{buildNumber}}
    </span>
  </div>
</footer>
